import {makeActionCreator} from '../../redux-toolbelt-10bis';

export const setIsNdeAnalyticsIdle = makeActionCreator<'setIsNdeAnalyticsIdle', boolean>('setIsNdeAnalyticsIdle');
